module.exports = __webpack_public_path__ + "img/home-docs.71c05b1a.png";